import { motion } from "framer-motion";
import { Users, Hand } from "lucide-react";

const situations = [
  {
    icon: Users,
    title: "Hay personas que se pierden por el camino",
    desc: "No porque no te importe. Sino porque es imposible estar en todo.",
  },
  {
    icon: Hand,
    title: "Hay cosas que siempre acaban en tus manos",
    desc: "Por mucho que quieras delegar, hay cosas que solo tú terminas haciendo.",
  },
];

const fade = {
  initial: { opacity: 0, y: 14 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-40px" },
  transition: { duration: 0.75 },
};

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1 } },
};

const item = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export default function ProblemSolutionSection() {
  return (
    <section
      id="problema-solucion"
      data-testid="problem-solution-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="mx-auto max-w-5xl px-4 sm:px-6 md:px-12">
        {/* Encabezado */}
        <motion.div {...fade} className="text-center max-w-3xl mx-auto mb-12 md:mb-14">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-gold mb-4">
            ¿Te suena?
          </p>
          <h2
            data-testid="problem-solution-title"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-ink tracking-tight"
          >
            Seguro que algo de esto te resulta familiar...
          </h2>
        </motion.div>

        {/* Dos situaciones */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="grid gap-6 md:grid-cols-2"
          data-testid="situations"
        >
          {situations.map(({ icon: Icon, title, desc }) => (
            <motion.div
              key={title}
              variants={item}
              className="rounded-3xl border border-violet-light bg-[#FAFAFE] p-7 md:p-9"
            >
              <span className="mb-5 flex h-12 w-12 items-center justify-center rounded-2xl bg-violet-fuerte/10 text-violet-fuerte">
                <Icon className="h-5 w-5" strokeWidth={2} />
              </span>
              <h3 className="font-display text-xl md:text-2xl font-bold text-ink tracking-tight leading-snug">
                {title}
              </h3>
              <p className="mt-3 text-lg text-ink-2 leading-relaxed">{desc}</p>
            </motion.div>
          ))}
        </motion.div>

        {/* Cierre */}
        <motion.p
          {...fade}
          data-testid="problem-solution-closing"
          className="mx-auto mt-12 max-w-2xl text-center text-xl md:text-2xl text-ink-2 leading-relaxed md:mt-14"
        >
          Para eso está{" "}
          <span className="font-semibold text-violet-fuerte">EkklesiaOnline</span>.
          Para que nada se pierda y puedas dedicarte a lo que más importa.
        </motion.p>
      </div>
    </section>
  );
}
